import * as Immutable from "immutable";
import { Panel } from "./panel";

export class HeaderPanel extends Panel {

  protected readonly MINOR_HEADER = "minorHeader";

  get minorHeader(): boolean { return this.getInternalValue<boolean>(this.MINOR_HEADER); }
  setMinorHeader(minorHeader: boolean): this { return this.setInternalValue(this.MINOR_HEADER, minorHeader); }
}